import React from 'react';
import Store from './store';
import GettingStartedPlan from './components/GettingStartedPlan';

export default props => (
  <Store>
    <GettingStartedPlan {...props} />
  </Store>
);



// WEBPACK FOOTER //
// ./app/javascript/components/getting_started/plan.js